import schoolDetail from './school-detail/index';

export default {
  modules: {
    'school-detail': schoolDetail,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/school/index.js